module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/assessment_achievements/3_9c2690c987a8365819ae67aa983ada9b.jpg";